import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useForm, Controller } from "react-hook-form";
import { UserInputData } from '../WarrantyFrame';
import CheckListTable from '../../../checkListTable'

export default function InsForm4YT(props) {
    const { currentState, setCurrentState } = useContext(UserInputData);
    const { control, getValues, setValue, } = useForm({
        defaultValues: { ...currentState, ...currentState },
        mode: 'onChange'
    });
    const [valueOnChange, setValueOnChange] = useState(false)
    const [isComplete, setIsComplete] = useState(0)
    const [resetValues, setResetValues] = useState(false)

    useEffect(() => {
        let upDateArray = JSON.parse(JSON.stringify(currentState));
        upDateArray = getValues();
        setCurrentState(upDateArray)
    }, [valueOnChange])

    useEffect(() => {
        //親フォームで取得した点検項目の値をセット
        if (currentState) {
            Object.entries(currentState).forEach(([key, value]) => {
                setValue(key, value)
            })
            setIsComplete(isComplete + 1)
        }
    }, [props.isEffectDone])

    useEffect(() => {
        //セットした値を元にチェックボックスへ反映
        if (isComplete === 2) {
            setResetValues(!resetValues)
        }
    }, [isComplete])

    const handleCheckListValues = (returnValue) => {
        if (!Object.keys(returnValue)[0]) return;
        for (let i = 0; i < Object.keys(returnValue).length; i++) {
            setValue(Object.keys(returnValue)[i], String(Object.values(returnValue)[i]))
        }
        setValueOnChange(!valueOnChange)
    };
    return (
        <React.Fragment>
            <Typography sx={{ fontSize: '2rem', }}>3　定期点検項目</Typography>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>外部</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.基礎</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="kiso"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'kisoHudoTinka',
                                        label: '不同沈下',
                                        value: parseInt(getValues("kisoHudoTinka"))
                                    }, {
                                        id: 'kisoKiretu',
                                        label: '亀裂',
                                        value: parseInt(getValues("kisoKiretu"))
                                    }, {
                                        id: 'kisoSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("kisoSonota"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>2.外装材</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="gaisozai"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'gaisoWare',
                                        label: '割れ、欠け、ヒビ',
                                        value: parseInt(getValues("gaisoWare"))
                                    }, {
                                        id: 'gaisoJoint',
                                        label: 'ジョイント部シーリング',
                                        value: parseInt(getValues("gaisoJoint"))
                                    }, {
                                        id: 'gaisoToriaibu',
                                        label: '取合部シーリング',
                                        value: parseInt(getValues("gaisoToriaibu"))
                                    }]} />
                            )}
                        />
                    </Grid>

                    <Typography sx={{ fontSize: '1.5rem', }}>3.外壁</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="gaiheki"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'gaihekiHenkei',
                                        label: '変形・不陸の有無',
                                        value: parseInt(getValues("gaihekiHenkei"))
                                    }, {
                                        id: 'gaihekiAmamizu',
                                        label: '雨水の浸入',
                                        value: parseInt(getValues("gaihekiAmamizu"))
                                    }, {
                                        id: 'gaihekiSonota',
                                        label: 'その他',
                                        value: parseInt(getValues("gaihekiSonota"))
                                    }]} />
                            )}
                        />
                    </Grid>

                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>4.バルコニー</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="balcony"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'barukoniRekka',
                                        label: '塗膜の劣化有無',
                                        value: parseInt(getValues("barukoniRekka"))
                                    }, {
                                        id: 'barukoniTukiStatus',
                                        label: '柱化粧飾の通気状態',
                                        value: parseInt(getValues("barukoniTukiStatus"))
                                    }, {
                                        id: 'barukoniMokubu',
                                        label: '木部の劣化',
                                        value: parseInt(getValues("barukoniMokubu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>5.屋根（目視）</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="roof"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'yaneTakezai',
                                        label: '屋根葺材',
                                        value: parseInt(getValues("yaneTakezai"))
                                    }, {
                                        id: 'yaneKabi',
                                        label: '苔、カビの発生',
                                        value: parseInt(getValues("yaneKabi"))
                                    }, {
                                        id: 'yaneNokisaki',
                                        label: '軒先、ケラバの状態',
                                        value: parseInt(getValues("yaneNokisaki"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>6.フラワーBOX妻飾り</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="flower"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'flowerTorituke',
                                        label: '取付の状態',
                                        value: parseInt(getValues("flowerTorituke"))
                                    }, {
                                        id: 'flowerKanagu',
                                        label: '金具の状態',
                                        value: parseInt(getValues("flowerKanagu"))
                                    }, {
                                        id: 'flowerToriaibu',
                                        label: '取合部',
                                        value: parseInt(getValues("flowerToriaibu"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>外部建具</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>1.全般</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="zenpan"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'zenpanTateguSokumen',
                                        label: '建具の側面',
                                        value: parseInt(getValues("zenpanTateguSokumen"))
                                    }, {
                                        id: 'zenpanTateguSita',
                                        label: '建具の下框',
                                        value: parseInt(getValues("zenpanTateguSita"))
                                    }, {
                                        id: 'zenpanKanaguSabi',
                                        label: '金具の錆',
                                        value: parseInt(getValues("zenpanKanaguSabi"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.5rem', }}>2.防水</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Controller
                            control={control}
                            name="bousui"
                            render={() => (
                                <CheckListTable setValue={handleCheckListValues}
                                    resetValues={resetValues}
                                    RowTitle={[{
                                        id: 'bousuiSanpo',
                                        label: '三方シーリング',
                                        value: parseInt(getValues("bousuiSanpo"))
                                    }, {
                                        id: 'bousuiSasikomi',
                                        label: '水切差込部',
                                        value: parseInt(getValues("bousuiSasikomi"))
                                    }, {
                                        id: 'bousuiRyoutan',
                                        label: '水切両端シーリング',
                                        value: parseInt(getValues("bousuiRyoutan"))
                                    }]} />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>特別</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>バルコニー</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Controller
                                control={control}
                                name="tokubetsu"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'barukoniComfirm',
                                            label: '防腐処理部の確認柱・梁・加工部の経年劣化状態の確認',
                                            value: parseInt(getValues("barukoniComfirm"))
                                        },]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>準防地域</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>防火ダンパー付外部給排気口</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="boka"
                                render={() => (
                                    <CheckListTable setValue={handleCheckListValues}
                                        resetValues={resetValues}
                                        RowTitle={[{
                                            id: 'bousuiDanpaFuzu',
                                            label: 'ヒューズ切有無',
                                            value: parseInt(getValues("bousuiDanpaFuzu"))
                                        }, {
                                            id: 'bousuiDanpaYogore',
                                            label: '汚れ、目詰まり',
                                            value: parseInt(getValues("bousuiDanpaYogore"))
                                        }, {
                                            id: 'bousuiDanpaSonota',
                                            label: 'その他',
                                            value: parseInt(getValues("bousuiDanpaSonota"))
                                        }]} />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </React.Fragment>
    )
}
